import React, { useEffect } from 'react';
import ItemDisplay from './ItemDisplay';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getItem,settoggleOpenShopItem,setCountItemBay } from '../../../redux/Item-reducer';
import { getItemStore, getIsFetchingItem, GetColorSimilar, GetColorIdSimilar, GetSeriesSimilar, GetCollectionSimilar, GetArtyclesSimilar, getBasketItemsId, GetArtyclesSimilarCount, GetCollectionSimilarCount, GetColorIdSimilarCount, GetSeriesSimilarCount, GetCollectionSimilarUrl, GetArtyclesSimilarUrl, GetSeriesSimilarUrl, GetColorIdSimilarUrl, GetProducerSimilarUrl, GetShopOrder, getIsOpenShopItem, getBasketIdItemsCanBuy,GetUserItems, GetSmilaraiSimilar, GetSmilaraiSimilarCount, GetSmilaraiSimilarUrl } from '../../../redux/filter-selectors';
import {  getCatalogItemsFish,getBasketIdItemsFish } from '../../../redux/catologItems-reducer.js';
import  { setUserItems } from "../../../redux/user-reduser";
import { compose } from 'redux';
import { connect } from 'react-redux';
import Error404 from '../../Error404/Error404';
import SkeletonItem from './SkeletonItem/SkeletonItem';
import { useMediaQuery } from 'react-responsive';
import SkeletonItemMoby from './SkeletonItem/SkeletonItemMoby';

export const withRouterItem = WrappedComponent => props => {
    let params = useParams();
    let location = useLocation();
    let navigate = useNavigate();
    // etc... other react-router-dom v6 hooks
    return (
        <WrappedComponent
            {...props}
            params={{ params, navigate, location }}
        // etc...
        />
    );

}

const ItemOrganzaContainer = (props) => {
    let itemcodurl = props.params.params.itemcodurl;
    const isDesktopOrLaptop = useMediaQuery({ minWidth: 1224 })
    const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 })
    // const isBigScreen = useMediaQuery({ minWidth: 1824 })
    // const isPortrait = useMediaQuery({ orientation: 'portrait' })
    // const isRetina = useMediaQuery({ minResolution: '2dppx' })

    useEffect(() => {
        
        props.getBasketIdItemsFish();
        props.setUserItems();
        // console.log(itemcodurl)
        if (itemcodurl !== "") {
            props.getItem(itemcodurl);
        }


    }, [itemcodurl])
    
    return (
        <>
        {!props.isFetchingItem && isDesktopOrLaptop && <SkeletonItem/>}
        {!props.isFetchingItem && isTabletOrMobile && <SkeletonItemMoby/>}
            {props.isFetchingItem &&

                props.item.ID !== 0  ?
                <ItemDisplay {...props} />
                :
                props.isFetchingItem &&
                 <Error404 />
            }
        </>
    )
}
let f1 = (store) => {

    return {
        item: getItemStore(store),
        isFetchingItem: getIsFetchingItem(store),
        colorSimilar: GetColorSimilar(store),
        coloridSemilar: GetColorIdSimilar(store),
        coloridSemilarCount:GetColorIdSimilarCount(store),
        coloridSemilarUrl:GetColorIdSimilarUrl(store),
        seriesSemilar: GetSeriesSimilar(store),
        seriesSemilarCount:GetSeriesSimilarCount(store),
        seriesSemilarUrl:GetSeriesSimilarUrl(store),
        collectionSemilar: GetCollectionSimilar(store),
        collectionSemilarCount: GetCollectionSimilarCount(store),
        collectionSemilarUrl: GetCollectionSimilarUrl(store),
        articlesSemilar: GetArtyclesSimilar(store),
        smilaraiSemilar: GetSmilaraiSimilar(store),
        smilaraiSemilarCount: GetSmilaraiSimilarCount(store),
        smilaraiSemilarUrl: GetSmilaraiSimilarUrl(store),
        articlesSemilarCount: GetArtyclesSimilarCount(store),
        articlesSemilarUrl: GetArtyclesSimilarUrl(store),
        basketitemsId: getBasketItemsId(store),
        producerSimilarUrl:GetProducerSimilarUrl(store),
        shopOrder:GetShopOrder(store),
        isOpenShop:getIsOpenShopItem(store),
        arBasketItemsCanBuy: getBasketIdItemsCanBuy(store),
        itemsUser: GetUserItems(store),
    }
}

export default compose(
    connect(f1, { getItem, getCatalogItemsFish, settoggleOpenShopItem,getBasketIdItemsFish,setUserItems,setCountItemBay }),
    withRouterItem,
)(ItemOrganzaContainer);
